import client from '@/lib/http-client';

const endpoint = 'private-order-items';

// eslint-disable-next-line import/prefer-default-export
export const getList = (params, callback, errCallback) => {
	const url = `${endpoint}/${params.orderId}`;
	client.get(url, { params }).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};
